import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Button } from "../../components/ui/button";
import LegalInfo from "../components/LegalInfo";

export default function Error() {
    return (
        <>
            <Helmet>
                <title>404 - Stránka neexistuje | De Vries Group, a.s.</title>
            </Helmet>
            <main className="min-h-screen flex flex-col bg-gray-50">
                <div className="flex-1 flex md:items-center justify-center py-24 min-h-screen">
                    <section className="text-center px-4">
                        <Link to="/" className="inline-block mb-6">
                            <img src="/logo.png" width={180} alt="De Vries Group" />
                        </Link>
                        <h1 className="text-7xl font-bold text-[#082359] mt-8">404</h1>
                        <p className="text-lg text-gray-500 mt-4 mb-8">Tato stránka neexistuje.</p>
                        <Button asChild>
                            <Link to="/">Přejít domů</Link>
                        </Button>
                    </section>
                </div>
                <LegalInfo variant="footer" />
            </main>
        </>
    );
}
